export default "__VITE_ASSET__DNJWj2IY__"